jQuery(document).ready(function ($) {
  var $slider = $('.product-gallery');

  if (!$slider.hasClass('slick-initialized')) {
    $slider.slick({
     infinite: true,        
      slidesToShow: 1,       
      slidesToScroll: 1,
      arrows: true,         
      dots: true,            
      autoplaySpeed: 3000, 
      adaptiveHeight: true, 
      swipe: true,         
      touchMove: true,     
      draggable: true,     
      swipeToSlide: true,

      prevArrow: `
        <button class="slide-arrow prev-arrow" aria-label="Previous">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <polygon points="16.707 4.707 9.414 12 16.707 19.293 15.293 20.707 6.586 12 15.293 3.293 16.707 4.707"/>
          </svg>
        </button>
      `,
      nextArrow: `
        <button class="slide-arrow next-arrow" aria-label="Next">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <polygon points="7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"/>
          </svg>
        </button>
      `,
    });
  }


    
    var initRelatedSlider = setInterval(function () {
      var $sliderrelated = $('.related-products .grid');

      if ($sliderrelated.length && !$sliderrelated.hasClass('slick-initialized')) {
        $sliderrelated.slick({
         slidesToShow: 3, // shows 3 full + little of 4th
            slidesToScroll: 1,
            arrows: false,    
            dots: true,       
            infinite: true,   
            swipe: true,         
            touchMove: true,     
            draggable: true,     
            swipeToSlide: true,
           prevArrow: `
        <button class="slide-arrow prev-arrow" aria-label="Previous">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <polygon points="16.707 4.707 9.414 12 16.707 19.293 15.293 20.707 6.586 12 15.293 3.293 16.707 4.707"/>
          </svg>
        </button>
      `,
      nextArrow: `
        <button class="slide-arrow next-arrow" aria-label="Next">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <polygon points="7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"/>
          </svg>
        </button>
      `,
          responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } }
          ]
        });

        // Stop checking after initialization
        clearInterval(initRelatedSlider);
      }
    }, 300); // checks every 300ms


if($(window).width() < 767){
    var $instagramgrid = $('.instagram-grid');

  if (!$instagramgrid.hasClass('slick-initialized')) {
    $instagramgrid.slick({
     infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,
    dots: false,
    autoplay: true,          
    autoplaySpeed: 2000,     
    speed: 1000,              
    adaptiveHeight: true,
    swipe: true,
    touchMove: true,
    draggable: true,
    swipeToSlide: true,
    pauseOnHover: false,     
    pauseOnFocus: false,  

      prevArrow: `
        <button class="slide-arrow prev-arrow" aria-label="Previous">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <polygon points="16.707 4.707 9.414 12 16.707 19.293 15.293 20.707 6.586 12 15.293 3.293 16.707 4.707"/>
          </svg>
        </button>
      `,
      nextArrow: `
        <button class="slide-arrow next-arrow" aria-label="Next">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <polygon points="7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"/>
          </svg>
        </button>
      `,
    });
  }
}


}) //ready function


$(document).ready(function () {
  var initFeaturedSlider = setInterval(function () {
    var $slider = $('#Slider-template--24955792523645__featured_collection_AxNWaz');

    if ($slider.length && !$slider.hasClass('slick-initialized')) {
  $slider.slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  infinite: true,      // loop enabled
  swipe: true,         
  touchMove: true,     
  draggable: true,     
  swipeToSlide: true,
  centerMode: false,   // 👈 disables centering
  // variableWidth: true, // optional if you want flexible slide widths
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 3 } },
    { breakpoint: 992,  settings: { slidesToShow: 2 } },
    { breakpoint: 576,  settings: { slidesToShow: 1 } }
  ]
});

      clearInterval(initFeaturedSlider);
    }
  }, 300);
}); // ready function


// $(document).ready(function () {
//   var $gallery = $('#Slider-Gallery-template--24955792753021__main');

//   if ($gallery.length && !$gallery.hasClass('slick-initialized')) {
//     $gallery.slick({
//       infinite: true,        // Enables looping (like Swiper loop: true)
//       slidesToShow: 1,       // One image at a time
//       slidesToScroll: 1,
//       arrows: true,          // Use prev/next arrows
//       dots: true,            // Show navigation dots
//       autoplay: true,        // Auto slide
      
//     });
//   }
// });



document.addEventListener('DOMContentLoaded', function () {
  // Utility: Format price like "€1,00 EUR"
  function formatMoney(cents, currency = 'EUR') {
    const amount = cents / 100;
    const formatted = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'symbol'
    }).format(amount);
    return `${formatted} ${currency}`;
  }

  // Get currency from Shopify if available
  const shopCurrency = window.Shopify?.currency?.active || 'EUR';

  // Handle "+" button click on grid
  document.querySelectorAll('.add-from-grid').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();

      const variantCount = parseInt(this.dataset.variantCount, 10);
      const available = this.dataset.available === 'true';
      const handle = this.dataset.handle;
      const firstVariantId = this.dataset.firstVariantId;

      if (!available) {
        alert("This product is sold out.");
        return;
      }

      if (variantCount === 1) {
        // Direct add to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: firstVariantId, quantity: 1 })
        })
        .then(res => res.json())
        .then(data => {
          window.location.href = '/cart';
        })
        .catch(err => {
          console.error(err);
          alert('Error adding to cart.');
        });
      } else {
        // Fetch product data for variant selection
        fetch(`/products/${handle}.js`)
          .then(res => res.json())
          .then(product => {
            showVariantPopup(product);
          });
      }
    });
  });

  // Display variant popup with option radios
  function showVariantPopup(product) {
    const popup = document.createElement('div');
    popup.classList.add('variant-popup');

    const optionsHTML = product.options.map((optionName, index) => {
      const values = [...new Set(product.variants.map(v => v.options[index]))];

      const radios = values.map(value => `
        <label class="variant-radio">
          <input type="radio" name="option-${index}" value="${value}">
          <span>${value}</span>
        </label>
      `).join('');

      return `
        <div class="option-group">
          <strong>${optionName.name}:</strong><br>
          ${radios}
        </div>
      `;
    }).join('');

    popup.innerHTML = `
      <div class="popup-inner">
        <h2>${product.title}</h2>
        <div id="variant-options">${optionsHTML}</div>
        <button id="add-variant-btn" disabled>Add to Cart</button>
        <button class="close-popup" type="button" onclick="document.body.removeChild(document.querySelector('.variant-popup'))"> &times;
</button>
      </div>
    `;
    document.body.appendChild(popup);

    const addButton = document.getElementById('add-variant-btn');

    // Listen to changes in variant options
    document.querySelectorAll('#variant-options input').forEach(input => {
      input.addEventListener('change', () => {
        const selectedOptions = getSelectedOptions(product.options.length);
        const matchingVariant = findMatchingVariant(product, selectedOptions);

        if (matchingVariant && matchingVariant.available) {
          addButton.disabled = false;
          addButton.dataset.variantId = matchingVariant.id;
          addButton.textContent = `Add to Cart`;
        } else {
          addButton.disabled = true;
          addButton.removeAttribute('data-variant-id');
          addButton.textContent = `Add to Cart`;
        }
      });
    });

    // Add selected variant to cart
    addButton.addEventListener('click', function () {
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => res.json())
      .then(data => {
        window.location.href = '/cart';
        document.body.removeChild(document.querySelector('.variant-popup'));
      })
      .catch(err => {
        console.error(err);
        alert('Failed to add variant.');
      });
    });
  }

  // Get selected option values
  function getSelectedOptions(optionCount) {
    let options = [];
    for (let i = 0; i < optionCount; i++) {
      const selected = document.querySelector(`input[name="option-${i}"]:checked`);
      if (!selected) return null;
      options.push(selected.value);
    }
    return options;
  }

  // Find matching variant by selected options
  function findMatchingVariant(product, selectedOptions) {
    if (!selectedOptions) return null;
    return product.variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
  }
});


// wishlist page language translate

$(document).ready(function() {
  function updateSwymTexts() {
    // Tabs
    $('.swym-storefront-layout-tab-button[data-view="tabWishlist"]').text('Wishlist');
    $('.swym-storefront-layout-tab-button[data-view="tabSavedForLater"]').text('Saved for later');

    // Login heading
    $('.swym-storefront-layout-login-heading').text("Don't lose your lists!");

    // Login description
    $('.swym-storefront-layout-login-description').text("Sign in to save your favorites and access them anytime!");

    // Login button (replace only the text, keep the SVG)
    $('.swym-storefront-layout-login-button').contents().filter(function() {
      return this.nodeType === 3; // only change text nodes
    }).first().replaceWith("Sign in & Save ");

    // Title "Meine Wunschliste"
    $('.swym-storefront-layout-title').contents().filter(function() {
      return this.nodeType === 3; // only text node, not SVG
    }).first().replaceWith("My Wishlist ");

    // Item count "1 Artikel" -> "1 Item(s)"
    $('#swym-storefront-layout-total-list-items-count').text(function(_, oldText) {
      return oldText.replace('Artikel', 'Item(s)');
    });

    // Empty saved-for-later title
    $('.swym-storefront-layout-empty-sfl-title').text("No items saved for later");

    // Empty saved-for-later description
    $('.swym-storefront-layout-empty-sfl-description').text("Save items from your cart here until you are ready");

    // View cart button
    $('.swym-storefront-layout-empty-sfl-view-cart-button').text("View Cart");

   $('.swym-storefront-layout-title').text("Saved for later");

    // $('.custom-price span').text("Price");
    // $('.custom-vailability span').text("Availability");
   

   
  }

  // Run immediately and a few more times to catch late rendering
  updateSwymTexts();
  setTimeout(updateSwymTexts, 1000);
  setTimeout(updateSwymTexts, 3000);
  setTimeout(updateSwymTexts, 5000);
}); //ready


$(document).ready(function () {
    $('.metafield-multi_line_text_field').each(function () {
        let content = $(this).html();

        // check if HTML is escaped
        if (content.includes('&lt;') || content.includes('&gt;')) {
            $(this).html($(this).text()); // decode ONLY if escaped
        }
    });
}); //ready